var _defs, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaranjaMentorangeVetor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 542.71 703.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fd481e;}.c{fill:#fd8762;}.d{fill:#2aad50;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 271.36,
    cy: 431.8,
    r: 271.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M301.08,290c15.4,7.35,32.56,10.95,47.03,20.23,15.13,9.71,23.71,26.06,27.65,43.25,2.94,12.83,3.88,26.03,6.38,38.95,3.82,19.75,13.98,47.08,38.63,45.26,7.28-.54,13.94-4.27,18.68-9.75,6.11-7.06,8.57-16.08,11.35-24.75,3.09-9.65,5.19-19.61,6.31-29.68,5-45.17-10.99-88.39-46.62-117.14-13.11-10.58-28.2-18.87-44.36-23.71-14.58-4.37-30.07-5.86-45.16-3.61-11.8,1.76-23.74,6.01-31.82,14.78-8.08,8.77-11.22,22.79-4.96,32.95,3.35,5.44,8.86,9.18,14.55,12.08,.78,.4,1.56,.78,2.35,1.16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M193.09,159.39c2.02-.52-6.26-32.4-6.83-34.34-7.27-24.54-19.29-48.02-36.91-66.76C116.78,23.65,67.83,11.71,23.28,.96,.07-4.63,.18,15.23,0,32.55c-.38,37.65,17.28,74.17,50.22,93.42,27.92,16.32,63.31,25.08,94.9,30.84,14.67,2.68,33.04,6.43,47.96,2.58Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaranjaMentorangeVetor);
export default __webpack_public_path__ + "static/media/laranja_mentorange-vetor.e2fbed66a3017c30c0e24430a9eb848e.svg";
export { ForwardRef as ReactComponent };